import React, { useState, useLayoutEffect, lazy } from "react";
import { Navigate } from "react-router-dom";
import { useStateContext } from "../context/ContextProvider.jsx";
import baseUrl from "../config/baseUrl.jsx";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';

/****Layouts*****/
import FullLayout from "../layouts/FullLayout/FullLayout.js";
/****End Layouts*****/

/*****Pages******/
import Login from "../views/Login/Login.js";
import Register from "../views/Register/Register.js";
import IncompleteProfile from "../views/Register/IncompleteProfile.js";
import Dashboard1 from "../views/dashboards/Dashboard1.js";
import MerchantDeposits from "../views/Deposits/MerchantDeposits.js";
import MerchantRefundCBR from "../views/RefundChargeback/RefundCBR.js";
import MerchantPayout from "../views/Payout/MerchantPayout.js";
import LocalSettlement from "../views/Settlement/Local/LocalSettlement.js";
import InternationalSettlement from "../views/Settlement/International/InternationalSettlement.js";
import MerchantReports from "../views/MerchantReports/MerchantReports.js";
import MerchantStatements from "../views/Statements/Statements.js";
import ReportPreview from "../views/Statements/ReportPreview.js";
import WalletLogs from "../views/Logs/WalletLogs.js";
import Teams from "../views/Teams/Teams.js";
import BusinessSetting from "../views/Setting/BusinessSetting.js";
import Integration from "../views/Integration/Integration.jsx";
import ChangePassword from "../views/ChangePassword/ChangePassword.js";

import TestSession from "../views/TestSession/TestSession.js";
import Singlepayout from "../views/SinglePayout/Singlepayout.js";
import PageNotFound from "../views/pageNotFound/PageNotFound.js";
import SubMerchant from "../views/SubMerchant/SubMerchant.js";
import ForgotPassword from "../views/Register/ForgotPassword.js";
import EmailVerification from "../views/Register/EmailVerification.js";
import SandboxDeposit from "../views/TestModule/SandboxDeposit/SandboxDeposit.js";
import SandboxPayout from "../views/TestModule/SandboxPayout/SandboxPayout.js";
import MerchantQR from "../views/MerchantQR/MerchantQr.js";

function Themeroutes() {
  const [modulePesmission, setModulePesmission] = useState([]);
  const { isLoginUser, setIsLoginUser, setAccoutType, accoutType } = useStateContext();

  useLayoutEffect(() => {
    if (sessionStorage.getItem('user')) {
      const { exp } = jwtDecode(sessionStorage.getItem('user'))
      const expirationTime = (exp * 1000) - 60000
      if (Date.now() >= expirationTime) {
        sessionStorage.clear();
        return [{
          path: "*",
          element: <Navigate to="/DepositPortal" replace />,
        }];
      }
      setIsLoginUser(sessionStorage.getItem('user'))
      setAccoutType(sessionStorage.getItem('accoutType'))
    }
    fetchData();
  }, [isLoginUser, accoutType]);

  const fetchData = async () => {
    try {
      let formData = new FormData();
      formData.append("token", isLoginUser);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${isLoginUser}`,
        },
      };

      let result;
      if (sessionStorage.getItem('user')) {
        result = await axios.post(`${baseUrl}/moduleEmployeePermission`, formData, config);
      }
      if (result && result.status === 200) {
        setModulePesmission(result.data.permission);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const getModulePermission = (name) => {
    const module = modulePesmission.find(m => m.module === name);
    return {
      authCreate: module?.m_add || 0,
      authRead: module?.m_view || 0,
      authUpdate: module?.m_edit || 0,
      authDelete: module?.m_delete || 0,
      authDownload: module?.m_download || 0,
    };
  };

  // Define routes dynamically based on user roles and session data
  if (isLoginUser && (accoutType ==='1' || accoutType === "0")) {
    return [
      {
        path: "/",
        element: <Navigate to="/DepositPortal" />,
      },
      { path: "/DepositPortal/report-preview", element: <ReportPreview /> },
      {
        path: "/DepositPortal/",
        element: <FullLayout modulePesmission={modulePesmission} />,
        children: [
          { path: "dashboard", element: <Dashboard1 authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "sub_merchant", element: <SubMerchant authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_deposits", element: <MerchantDeposits authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_payouts", element: <MerchantPayout authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_single_payouts", element: <Singlepayout authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "refund_chargebacks", element: <MerchantRefundCBR authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "local_settlements", element: <LocalSettlement authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "international_settlements", element: <InternationalSettlement authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_reports", element: <MerchantReports authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_statements", element: <MerchantStatements authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "wallet_logs", element: <WalletLogs authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "teams", element: <Teams authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "bussiness_setting", element: <BusinessSetting authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "integration", element: <Integration authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "change_password", element: <ChangePassword authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },

          // TEST MODULES
          { path: "merchant_test_deposits", element: <SandboxDeposit authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_test_payouts", element: <SandboxPayout authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
        ],
      },
    ];
  }

  if (isLoginUser && accoutType ==='3') {
    return [
      {
        path: "/",
        element: <Navigate to="/DepositPortal" />,
      },
      {
        path: "/DepositPortal/",
        element: <FullLayout modulePesmission={modulePesmission} />,
        children: [
          { path: "dashboard", element: <Dashboard1 authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "sub_merchant", element: <SubMerchant {...getModulePermission("Sub Merchant")} /> },
          { path: "merchant_deposits", element: <MerchantDeposits {...getModulePermission("Deposits")} /> },
          { path: "merchant_payouts", element: <MerchantPayout {...getModulePermission("Payouts")} /> },
          { path: "merchant_single_payouts", element: <Singlepayout {...getModulePermission("Singlepayout")} /> },
          { path: "refund_chargebacks", element: <MerchantRefundCBR {...getModulePermission("Refund & Chargebacks")} /> },
          { path: "local_settlements", element: <LocalSettlement {...getModulePermission("Settlements")} /> },
          { path: "international_settlements", element: <InternationalSettlement {...getModulePermission("Settlements")} /> },
          { path: "merchant_reports", element: <MerchantReports {...getModulePermission("Reports")} /> },
          { path: "merchant_statements", element: <MerchantStatements {...getModulePermission("Statements")} /> },
          { path: "wallet_logs", element: <WalletLogs {...getModulePermission("Wallet Logs")} /> },
          { path: "teams", element: <Teams {...getModulePermission("Teams")} /> },
          { path: "bussiness_setting", element: <BusinessSetting {...getModulePermission("Business Setting")} /> },
          { path: "integration", element: <Integration authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "change_password", element: <ChangePassword authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },

          // TEST MODULES
          { path: "merchant_test_deposits", element: <SandboxDeposit authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
          { path: "merchant_test_payouts", element: <SandboxPayout authCreate={1} authRead={1} authUpdate={1} authDelete={1} authDownload={1} /> },
        ],
      },
    ]
  }

  return [
    {
      path: "/DepositPortal",
      element: <Login />,
    },
    {
      path: "/DepositPortal/start-session-test-session-deposits/:user_id",
      element: <TestSession />,
    },
    {
      path: "/DepositPortal/signup-merchant",
      element: <Register />,
    },
    {
      path: "/DepositPortal/incomplete_profile",
      element: <IncompleteProfile />,
    },
    {
      path: "/DepositPortal/forgot_password",
      element: <ForgotPassword />,
    },
    {
      path: "/DepositPortal/merchant_verification/:user_id",
      element: <EmailVerification />,
    },
    {
      path: "/DepositPortal/merchant_QR",
      element: <MerchantQR />,
    },
    {
      path: "*",
      element: <PageNotFound />,
    }
  ];
}

export default Themeroutes;
